import vhCheck from 'vh-check';

if (vhCheck()) {
    document.documentElement.classList.add('needs-vh-offset');
} else {
    document.documentElement.classList.add('needs-no-vh-offset');
}
